import { render } from "./AltPlansView.vue?vue&type=template&id=133477ce"
import script from "./AltPlansView.vue?vue&type=script&lang=js"
export * from "./AltPlansView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__